<div [formGroup]="form">
	<div *ngIf="employeeLoadError" class="alert alert-danger" role="alert">
		Não foi possível carregar os dados do colaborador. Verifique a conexão e tente novamente.
	</div>
	<ng-container *ngIf="data?.mode === 'add'">
		<div class="form-group">
			<label class="form-control-label" for="">Colaborador</label>

			<ng-container *ngIf="data?.hasSubType">
				<div class="form-group">
					<ng-select class="auto-grow-options" [items]="lists.trainedEmployeeOptions" bindValue="id" bindLabel="name"
						placeholder="Colaborador" formControlName="employeeId" (change)="onTrainedEmployeeChanged($event)"
						[loading]="isTrainedEmployeeLoading"></ng-select>
				</div>
			</ng-container>

			<ng-container *ngIf="data?.employee?.name">
				<app-employee-info-display [employee]="data?.employee"></app-employee-info-display>
			</ng-container>
		</div>
	</ng-container>

	<div class="divider divider-primary">
		<div class="divider-text">Cenário Atual</div>
	</div>
	<div *ngIf="!isHidden('currentCostCenterId')" class="form-group">
		<label class="form-control-label" for="group">Centro de Custo</label>
		<ng-select class="cost-centers-options auto-grow-options" [attr.data-tooltip]="
				getSelectedOptionText(lists.currentCenterCostsOptions, form.get('currentCostCenterId')?.value)
			" [items]="lists.currentCenterCostsOptions" bindValue="value" bindLabel="label" placeholder="Centro de Custo"
			formControlName="currentCostCenterId" [readonly]="true"></ng-select>
	</div>

	<div *ngIf="!isHidden('currentJobTitleId')" class="form-group">
		<label class="form-control-label" for="group">Função</label>
		<ng-select container="body" class="cost-centers-options auto-grow-options" [attr.data-tooltip]="
				getSelectedOptionText(lists.currentJobTitleOptions, form.get('currentJobTitleId')?.value)
			" [items]="lists.currentJobTitleOptions" bindValue="value" bindLabel="label" placeholder="Função"
			formControlName="currentJobTitleId" [readonly]="true"></ng-select>
	</div>

	<div class="divider divider-primary">
		<div class="divider-text">Novo Cenário</div>
	</div>

	<div *ngIf="!isHidden('newCostCenterId')" class="form-group">
		<label class="form-control-label" for="group">Centro de Custo</label>
		<ng-select class="cost-centers-options auto-grow-options" [attr.data-tooltip]="
				getSelectedOptionText(lists.centerCostsOptions, form.get('newCostCenterId')?.value)
			" [items]="lists.centerCostsOptions" bindValue="value" bindLabel="label" placeholder="Centro de Custo"
			formControlName="newCostCenterId" (change)="onCenterCostChanged($event)"
			[readonly]="data?.hasSubType || isNewCostCenterLocked"></ng-select>
		<small *ngIf="isNewCostCenterLocked" class="text-muted">
			Este fluxo permite movimentação apenas dentro do centro de custo atual do colaborador.
		</small>
		<app-error-msg [control]="form.controls['newCostCenterId']" [label]="'Centro de Custo'">
		</app-error-msg>
	</div>

	<div *ngIf="!isHidden('newJobTitleId')" class="form-group">
		<label class="form-control-label" for="group">Função</label>
		<ng-select container="body" class="cost-centers-options auto-grow-options" [loading]="isJobTitlesLoading"
			[attr.data-tooltip]="
				getSelectedOptionText(lists.jobTitleOptions, form.get('newJobTitleId')?.value)
			" [items]="lists.jobTitleOptions" bindValue="value" bindLabel="label" placeholder="Função"
			formControlName="newJobTitleId" (change)="onJobTitleChange($event)" [readonly]="isNewJobTitleDisabled"></ng-select>
		<app-error-msg [control]="form.controls['newJobTitleId']" [label]="'Função'">
		</app-error-msg>
	</div>

	<app-salary-range-select *ngIf="!isHidden('salaryRange')" [jobTitleId]="form.get('newJobTitleId')?.value" [control]="form.controls['salaryRange']"
		[required]="isSalaryRangeRequired" (rangeSelected)="onSalaryRangeSelected($event)"></app-salary-range-select>

	<ng-container *ngIf="canShowFieldsToChangeJobTitleOrCostCenter">
		<div *ngIf="!isHidden('changeTypeCode')" class="form-group">
			<label class="form-control-label" for="changeTypeCode">Tipo de movimentação</label>
			<ng-select class="cost-centers-options auto-grow-options" title="Tipo de movimentação"
				[items]="lists.movementTypeOptions" bindValue="value" bindLabel="label" placeholder="Tipo de movimentação"
				formControlName="changeTypeCode"></ng-select>
			<app-error-msg [control]="form.controls['changeTypeCode']" [label]="'Tipo de movimentação'">
			</app-error-msg>
		</div>

		<div class="form-group" *ngIf="(!hasSalaryRange) && !isHidden('newSalary')">
			<label class="form-control-label" for="newSalary">Salário</label>
			<input type="text" id="newSalary" formControlName="newSalary" class="form-control" placeholder="R$ 0,00"
				appCurrencyCentsInput />
			<app-error-msg [control]="form.controls['newSalary']" [label]="'Salário'">
			</app-error-msg>
		</div>
	</ng-container>

	<div *ngIf="!isHidden('hasDangerousness')" class="form-group">
		<div class="d-flex gap-2 mb-small">
			<label class="form-control-label" for="hasDangerousness">Possui Periculosidade?</label>
			<div class="custom-control custom-switch custom-switch-success">
				<input type="checkbox" class="custom-control-input" id="hasDangerousness"
					formControlName="hasDangerousness" />
				<label class="form-control-label custom-control-label" for="hasDangerousness">
					<span class="switch-icon-left"><i data-feather="check"></i></span>
					<span class="switch-icon-right"><i data-feather="x"></i></span>
				</label>
			</div>
		</div>
	</div>

	<ng-container *ngIf="canShowExecutionDate">
		<div *ngIf="!isHidden('executionDate')" class="form-group">
			<label class="form-control-label" for="">Data da Execução</label>
			<input type="date" class="form-control" formControlName="executionDate" />
			<app-error-msg [control]="form.controls['executionDate']" [label]="'Data da Execução'">
			</app-error-msg>
		</div>
	</ng-container>

	<ng-container *ngIf="canShowTradeUnionField">
		<div *ngIf="!isHidden('tradeUnionId')" class="form-group">
			<label class="form-control-label" for="group">Sindicato</label>
			<ng-select class="cost-centers-options auto-grow-options" title="Sindicato da nova função"
				[items]="lists.tradeUnionsOptions" bindValue="value" bindLabel="label" placeholder="Sindicato da nova função"
				formControlName="tradeUnionId"></ng-select>
			<app-error-msg [control]="form.controls['tradeUnionId']" [label]="'Sindicato'">
			</app-error-msg>
		</div>
	</ng-container>

	<div *ngIf="!isHidden('unhealthinessType')" class="form-group">
		<label class="form-control-label">Insalubridade</label>
		<ng-select container="body" class="cost-centers-options auto-grow-options" title="Insalubridade"
			[items]="unhealthinessOptions" bindValue="value" bindLabel="label" placeholder="Insalubridade"
			formControlName="unhealthinessType"></ng-select>
		<app-error-msg [control]="form.controls['unhealthinessType']" [label]="'Insalubridade'">
		</app-error-msg>
	</div>

	<div class="form-group">
		<label class="form-control-label" for="">Justificativa</label>
		<textarea type="text" class="form-control" formControlName="note"></textarea>
		<app-error-msg [control]="form.controls['note']" [label]="'Justificativa'">
		</app-error-msg>
	</div>
</div>